import React from 'react';

interface TableShimmerProps {
  rows?: number;
  columns?: number;
}

export const TableShimmer: React.FC<TableShimmerProps> = ({
  rows = 10,
  columns = 5,
}) => {
  return (
    <div className="animate-pulse">
      {/* Table header */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <div className="flex gap-4 p-4">
          {Array.from({ length: columns }).map((_, index) => (
            <div
              key={`header-${index}`}
              className="h-4 bg-gray-200 dark:bg-gray-700 rounded flex-1"
            />
          ))}
        </div>
      </div>

      {/* Table rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          className="border-b border-gray-200 dark:border-gray-700"
        >
          <div className="flex gap-4 p-4">
            {Array.from({ length: columns }).map((_, colIndex) => (
              <div
                key={`cell-${rowIndex}-${colIndex}`}
                className="h-4 bg-gray-200 dark:bg-gray-700 rounded flex-1"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
